import {create} from "../../fjsc/src/f2.ts";
import {Generics, verticalPage} from "./generics.ts";
import {bagels} from "../constants/bagels.ts";
import { BagelInfo } from "../models/BagelInfo.ts";
import { signal } from "../../fjsc/src/signals.ts";

export class Home {
    static page() {
        let currentIndex = 0;
        const mainBagel = signal(bagels[0]!.image);
        setInterval(() => {
            currentIndex += 1;
            if (currentIndex > bagels.length - 1) {
                currentIndex = 0;
            }
            mainBagel.value = bagels[currentIndex]!.image;
        }, 1000);

        return Generics.pageFrame(
            false,
            verticalPage(
                Generics.image("/images/sayos_bagels.png", ["home-image"]),
                Generics.image(mainBagel, ["spinning-image"]),
                create("h2")
                    .classes("flex-v")
                    .children(
                        create("span")
                            .text("home of handmade bagels")
                            .build(),
                    ).build(),
                Home.bagels()
            ),
        );
    }

    private static bagels() {
        return create("div")
            .classes("home-grid")
            .children(
                ...bagels.map(b => Home.bagel(b))
            ).build();
    }

    private static bagel(b: BagelInfo) {
        return create("img")
            .classes("home-bagel")
            .src(b.image)
            .title(b.name)
            .build();
    }
}